import React from 'react';
import { createMuiTheme } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/styles';
import AppWrapper from './components/AppWrapper.js';
import './Firebase.js';
import AuthContextProvider from './contexts/AuthContext.js';

const theme = createMuiTheme({
  palette: {
    primary: { main: '#ffffff',
	       green: '#1ce3b6',
	       grey: '#f6f6f6',
	       red: '#f62152',
	       brown: '#602d22',
	       yellow: '#f5e365'},
    secondary: { main: '#1ce3b6' },
    type: 'light',
  },
});

const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <AuthContextProvider>
	<AppWrapper/>
      </AuthContextProvider>
    </ThemeProvider>
  );
};

export default App;
